import axios from "axios"

export default axios.create({
 //baseURL: "http://localhost:80/api", //Dev
 //baseURL: "/api", //Production
 baseURL: process.env.VUE_APP_BASE_URL,
 withCredentials: true,
 })